const AbsenceReasons = {
    options: [
        {value: "MEDICAL_CERTIFICATE", label: "Atestado"},
        {value: "CAT", label: "Atestado médico CAT"},
        {value: "UNJUSTIFIED_ABSENCE", label: "Falta injustificada"},
        {value: "JUSTIFIED_ABSENCE", label: "Falta justificada"},
        {value: "VACATION", label: "Férias"},
        {value: "DAY_OFF", label: "Folga"},
        {value: "PAID_DAY_OFF", label: "Folga abonada"},
        {value: "LICENSE", label: "Licença"},
        {value: "PREMIUM_LICENSE", label: "Licença prêmio"},
        {value: "SHIFT_CHANGE", label: "Troca de plantão"},
    ],

    getAbsenceReasons: () => {
        return AbsenceReasons.options;
    },

    toView: (reason) => {
        if (!reason) return "";

        return AbsenceReasons.options.find(({value}) => reason === value)?.label ?? "";
    }
}

export default AbsenceReasons;